<template>
  <div>
    <div v-if="!admin">
      <slot></slot>
    </div>
    <div v-if="admin">
      <header id="header" class="u-header--starter">
        <nav
          id="logoAndNav"
          class="navbar navbar-dark lex-nowrap p-0"
          style="background-color: #fff;"
        ></nav>
      </header>
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-lg-2 hide no_padding_left shadow_bar_right pt-4 col-md-2 col-xs-12 bg_menu full_height"
          >
            <div class="col-xl-2 col-md-2 center col-lg-2 mr-0 py-3 pf-5">
              <img src="/images/Jovool_logo.png" width="120px" />
            </div>
            <MenuAdminItem
              label="Dashboard"
              url="/recruiters/dashboard"
              img="/images/DASHBOARD_ICON.png"
              img_active="/images/DASHBOARD_COLOR_ICON.png"
              :active="menu"
            />

            <MenuAdminItem
              label="Vagas"
              url="/recruiters/jobs"
              img="/images/VAGA_ICON.png"
              img_active="/images/VAGA_COLOR_ICON.png"
              :active="menu"
            />

            <MenuAdminItem
              label="Videos"
              url="/recruiters/videos"
              img="/images/VIDEOS_ICON.png"
              img_active="/images/VIDEOS_COLOR_ICON.png"
              :active="menu"
            />

            <MenuAdminItem
              label="Live"
              url="/recruiters/rooms"
              img="/images/LIVE_ICON.png"
              img_active="/images/LIVE_COLOR_ICON.png"
              active="Live"
            />

            <MenuAdminItem
              label="Pagamentos"
              url="#"
              img="/images/PAGAMENTOS_ICON.png"
              img_active="/images/PAGAMENTOS_COLOR_ICON.png"
              :active="menu"
            />

            <MenuAdminItem
              label="Integrações"
              url="#"
              img="/images/INTEGRACOES_ICON.png"
              img_active="/images/INTEGRACOES_COLOR_ICON.png"
              :active="menu"
            />

            <MenuAdminItem
              label="Configuraçoes"
              url="#"
              img="/images/CONFIGURAÇOES_ICON.png"
              img_active="/images/CONFIGURAÇOES_COLOR_ICON.png"
              :active="menu"
            />
          </div>
          <div class="col-lg-12 col-md-2 col-xs-12 pr-0 pl-0">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuAdminItem from "components/MenuAdminItem.vue";
export default {
  components: { MenuAdminItem },
  props: ["admin"],
};
</script>